<template lang="pug">
.v-site-switch.site-switch(v-if="data" :id="data?.id")
	a.site-switch__item(v-for="item in data.items" :href="item.link" :class="{'active': item.active}") {{item.text}}
</template>

<script>

import sourceMixin from "../components/mixins/v-mixin-source.vue";

export default {
	mixins: [
		sourceMixin
	],

	data() {
		return {
			data: null
		}
	},

	methods: {
		dataSet(data) {
			this.data = data;
		}
	}
}

</script>